// extracted by mini-css-extract-plugin
export default {"container":"TableauGabarit_container__curl-"};